<div class="flex flex-row justify-between items-center search-container">
  <input (keyup)="onKeyUp($event)" class="fw-400 h-34 no-border" placeholder="{{ placeholder | transloco }}"
         type="text" value="{{searchText}}" #searchInput>
  <mat-icon class="mr-16 icon-sm icon-color cursor-pointer" [svgIcon]="searchText ? 'close' : 'search'" (click)="clearInput()"></mat-icon>
</div>
